<template>
    <div class="outbox">
        <div class="out f-row-start-l wrap" v-if="picture.pictureType == '1' && bannerS.length > 0">
            <div class="wl"  @mouseenter="onMouseenter" @mouseleave="onMouseleave">
                <div class="iconbox-l iconbox-r">
                    <div class="icon-l-next pinter" @click="onNext"></div>
                </div>
                <div class="iconbox-l">
                    <div class="icon-l-pre pinter" @click="onPre"></div>
                </div>
                <el-image fit='cover' class="w-100 img" :src="$fileAccessHttpUrl(bannerS[act].imgUrl)"></el-image>
                <div class="cont f-row-c">
                    <span class="font-t">{{act+1}}</span>/<span class="font-s">{{bannerS.length}}</span>
                </div>
            </div>
            <div class="wr">
                <div class="icon-rt pinter" @click="prePage()"></div>
                <ul @mouseenter="onMouseenter" @mouseleave="onMouseleave">
                    <li class="imgbox f-row-c pinter" :class="act==ind?'actbox':''" v-for="(item,ind) in bannerS" :key='ind' @mouseenter="onhover(ind)">
                        <el-image v-if='item.imgUrl' fit='cover' class="w-100 img" :src="$fileAccessHttpUrl(item.imgUrl)"></el-image>
                    </li>

                </ul>
                <div class="icon-rb pinter" @click="nextPage()"></div>
            </div>
        </div>
        <div class="out-video"  v-if="picture.pictureType == '0'">
            <video :src="picture.videoUrl" controls="controls"></video>
        </div>
        <div class="cont" v-if="picture.pictureType == '1' && bannerS.length > 0">
            <!-- <div>{{bannerS[act].pictureId_dictText||''}}</div> -->
            <div>{{bannerS[act].content||''}}</div>
        </div>
        <div class="cont" v-if="picture.pictureType == '0'">
            <!-- <div>{{bannerS[act].pictureId_dictText||''}}</div> -->
            <div>{{picture.remark||''}}</div>
        </div>
    </div>
</template>

<script>
import {buildPictureItems} from '@/utils/volunteerNews'

export default {
    computed:{

    },
    name: 'phoneBooks',
    props:['is_index','id'],
    data() {
        return {
            timer:null,
            act:0,
            bannerS:[],
            pageNo:1,
            total:1,
            maxNum:1,
            info:[],
            picture:{},
        };
    },

    mounted() {
        this.getDetail(this.id)

    },
    beforeDestroy(){
        this.onMouseenter()
    },
    methods: {
        prePage(){
            if(this.pageNo>=1){
                this.pageNo--
                this.getInfo(this.id)
            }else{
                // this.pageNo=this.maxNum
            }
        },
        nextPage(){
            if(this.pageNo<this.maxNum){
                this.pageNo++
                this.getInfo(this.id)
            }else{
                // this.pageNo=1
            }
        },
        getDetail(id){
            var params={
                id:id,
            }

            this.$get('/web/home/queryPcitureById',params).then(res=>{
                if(res.success){
                    this.picture=res.result
                    if(this.picture.pictureType == '1'){
                        this.getInfo(id);
                    }

                    var videoUrl = this.picture.videoUrl
                    if (videoUrl) {
                        this.picture.videoUrl = this.$fileAccessHttpUrl(videoUrl)
                    }
                }
            })
        },
        getInfo(id){
            var params={
                pictureId:id,
                pageNo:this.pageNo,
                pageSize:4
            }

            this.$get('/web/home/pictureDetailsList',params).then(res=>{
                if(res.success){
                    var records = res.result && res.result.records ? res.result.records : []
                    this.act=0;
                    this.bannerS=buildPictureItems(records, this.picture)
                    this.total=res.result && res.result.total ? res.result.total : this.bannerS.length
                    this.maxNum=Math.ceil(this.total/4)
                    this.onMouseenter()//清除定时
                    if (this.bannerS.length > 1) {
                        this.setIntervalFn()//设置定时
                    }
                }
            })
        },
        onMouseenter(){
            clearInterval(this.timer)
            this.timer=null
        },
        onMouseleave(){
            this.setIntervalFn()
        },
        setIntervalFn(){
            if (this.timer || this.bannerS.length < 2) {
                return
            }
            this.timer=setInterval(()=>{
               this.onNext()
            },2000)
        },
        onhover(ind){
            this.act=ind
            // $(".pic ul li").hover(function(e){
            //     $(this).stop(true).animate({width:"800px"},1000).siblings().stop(true).animate({width:"100px"},1000);

            // });
        },
        onPre(){
            if(this.act>1){
                this.act--
            }else{
                this.act=this.bannerS.length-1
            }
        },
        onNext(){
            if(this.act<this.bannerS.length-1){
                this.act++
            }else{
                this.act=0
            }

        },
    },
};
</script>

<style lang="scss" scoped>
* {
    margin: 0px;
    padding: 0px;
    font-family: "微软雅黑";
    list-style: none;
}
.outbox{
    min-height: 630px;
}
.out{
    height: 571px;
}
.cont{
    line-height: 30px;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    width: calc(100% - 268px);
    margin-top: 20px;
}
.wl{
    width: calc(100% - 268px);
    height: 571px;
    overflow: hidden;
    position: relative;
    .img{width: 100%;height: 100%;}

    .cont{
        position: absolute;
        width: 100px;
        height: 58px;
        background: #BA0711;
        z-index: 2;
        left: 0px;
        bottom: 0px;
        color: #ffffff;
        .font-t{
            font-size: 34px;
        }
        .font-s{
            font-size: 20px;
        }
    }
}
.wr{
    width: 207px;
    margin-left: 61px;
    height: 100%;
    position: relative;
    ul{
        height: 100%;
        .imgbox{
            width: 207px;
            height: 129px;
            margin-bottom: 19px;
            overflow: hidden;
        }
        .actbox{
            border: 4px solid #BA0711;
        }
    }
}
.iconbox-l,.iconbox-r{
    height: 100%;
    width: 100px;
    position: absolute;
    left: 0px;
    z-index: 2;
}
.iconbox-r{
    left: auto;
    right: 0px;
}
.icon-l-next,.icon-l-pre{
    position: absolute;
    z-index: 2;
    background: url('./../../assets/img/banner-l.png') no-repeat;
    background-size: contain;
    width: 50px;
    height: 56px;
    right:10px;
    top: calc(50% - 28px);
    display: none;
}
.icon-l-pre{
    left:10px;
    right: auto;
    transform:rotate(180deg);
}
.iconbox-l:hover{
    .icon-l-next,.icon-l-pre{
        display: block!important;
    }
}

.icon-rt,.icon-rb{
    position: absolute;
    z-index: 2;
    background: url('./../../assets/img/banner-r.png') no-repeat;
    background-size: contain;
    width: 207px;
    height:35px;
    top:-55px;
    left: 0px;
}
.icon-rb{
    top: auto;
    bottom: -60px;
    transform:rotate(180deg);
}
.out-video{
    width: 100%;
    video{
        width: 100%;
    }
}
</style>
